"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGridLazyLoaderPreProcessors = exports.GRID_SKELETON_ROW_ROOT_ID = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _internals = require("@mui/x-data-grid/internals");
var _xDataGrid = require("@mui/x-data-grid");
var GRID_SKELETON_ROW_ROOT_ID = exports.GRID_SKELETON_ROW_ROOT_ID = 'auto-generated-skeleton-row-root';
var getSkeletonRowId = function(index) {
    return "".concat(GRID_SKELETON_ROW_ROOT_ID, "-").concat(index);
};
var useGridLazyLoaderPreProcessors = function(privateApiRef, props) {
    var addSkeletonRows = React.useCallback(function(groupingParams) {
        var rootGroup = groupingParams.tree[_xDataGrid.GRID_ROOT_GROUP_ID];
        if (props.rowsLoadingMode !== 'server' || !props.rowCount || rootGroup.children.length >= props.rowCount) {
            return groupingParams;
        }
        var tree = (0, _extends2.default)({}, groupingParams.tree);
        var rootGroupChildren = _to_consumable_array(rootGroup.children);
        for(var i = 0; i < props.rowCount - rootGroup.children.length; i += 1){
            var skeletonId = getSkeletonRowId(i);
            rootGroupChildren.push(skeletonId);
            var skeletonRowNode = {
                type: 'skeletonRow',
                id: skeletonId,
                parent: _xDataGrid.GRID_ROOT_GROUP_ID,
                depth: 0
            };
            tree[skeletonId] = skeletonRowNode;
        }
        tree[_xDataGrid.GRID_ROOT_GROUP_ID] = (0, _extends2.default)({}, rootGroup, {
            children: rootGroupChildren
        });
        return (0, _extends2.default)({}, groupingParams, {
            tree: tree
        });
    }, [
        props.rowCount,
        props.rowsLoadingMode
    ]);
    (0, _internals.useGridRegisterPipeProcessor)(privateApiRef, 'hydrateRows', addSkeletonRows);
};
exports.useGridLazyLoaderPreProcessors = useGridLazyLoaderPreProcessors;
